__gh__webApp.paywall.pianoVX = {
	"init": function(){

		if (this.isDisabled()) {return;}
		
		this.updateLoginLogoutText();
		this.bindEvents();
	},
	
	
	"bindEvents":function(){
		var thisObject = __gh__webApp.paywall;
		
		//Login event
		$(document).on('click','[data-gh-paywall-event=login]',function(event){
			event.preventDefault();
			thisObject.showUserLoginForm();
		});
		
		//Logout event
		$(document).on('click','[data-gh-paywall-event=logout]',function(event){
			event.preventDefault();
			thisObject.logout();
		});
	},
	
	
	"isDisabled": function(){
		var commonJS = __gh__webApp.common;
		return (__gh__coreData["3rdPartyData"].paywall.pianoVX.disabled || !commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"paywall.pianoVX.aid"));
	},
	
	
	"isUserLoggedIn": function(){
		if (this.isDisabled()) {return false;}
		var commonJS 	= __gh__webApp.common,
			userCookie;
		if(userCookie = commonJS.getCookie("__ut")){
			return userCookie;
		}
		return false;
	},
	
	
	"showUserLoginForm": function(callback){
		if (this.isDisabled()) {return false;}
		
		var thisObject = __gh__webApp.paywall;
		tp.push(["init", function() {
			tp.user.showLogin({  
				loginSuccess:function() {
					thisObject.updateLoginLogoutText();
					if (callback){
						callback();
					}
				} 
			});
		}]);
	},
	
	"showOffer": function(options){
		if (this.isDisabled()) {return false;}
		
		var commonJS = __gh__webApp.common,
			offer = {
				"displayMode"	: (options.displayMode) ? options.displayMode : "modal",
				"templateId"	: (options.templateId) ? options.templateId : null,
				"offerId"		: (options.offerId) ? options.offerId : null
			};
		
		//Remove null or undefined items
		offer = commonJS.cleanObject(offer);
		
		tp.push(["init", function() {
		    tp.offer.show(offer);
		}]);
	},
	
	"updateLoginLogoutText": function(){
		if (this.isDisabled()) {return false;}
		
		var thisObject 	= __gh__webApp.paywall,
			$loginLink	= $("#toprail-login").find("a");
		
		//Log out text
		if (thisObject.isUserLoggedIn()) {
			$loginLink.find("span").html("log out");
			$loginLink.attr("data-gh-paywall-event","logout");
			return;
		}

		//Log in text
		$loginLink.find("span").html("log in");
		$loginLink.attr("data-gh-paywall-event","login");
		
	},
	"logout":function(){
		if (this.isDisabled()) {return false;}
		
		var thisObject = __gh__webApp.paywall;
		tp.push(["init", function() {
			tp.user.logout(function(){
				thisObject.updateLoginLogoutText();
			});
		}]);
	},
	"userLogin":function(callback){
		var callback = callback || null;
		this.showUserLoginForm(callback);
	},
	
	"refreshExperience": function(){
		if (this.isDisabled()) {return;}
		tp.experience.execute();
	},
	
	/**
	 * Library is loaded server side
	 */
	"loadLibrary": function() {},
	
	"meterArticle": function(articleID){},
	
	"sessionBar":{"incrementTotalPremiumClicks":function(){}},
};
